import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import { Observable } from 'rxjs'
import { Holiday } from '../components/hrmsLayout/leaves/holidays/holidays.component'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class HolidayService {
  private http = inject(HttpClient) // Use inject() instead of constructor injection
  private api = eps.leaves

  list(
    businessId: string,
    search: string,
    page: number,
    limit: number,
    year: number,
    officeId?: string
  ): Observable<{ totalCount: number; holidays: Holiday[] }> {
    // console.log('SERVICE officeId received:', officeId)
    let params = new HttpParams()
    if (businessId) {
      params = params.set('businessId', businessId)
    }
    if (officeId) {
      params = params.set('officeId', officeId)
    }

    // console.log('FINAL PARAMS:', params.toString()) // ✅ add this
    params = params.set('title', search)
    params = params.set('page', page)
    params = params.set('limit', limit)
    params = params.set('year', year)
    return this.http.get<{ totalCount: number; holidays: Holiday[] }>(this.api.holidaysApi, {
      params
    })
  }

  // create(holiday: Holiday): Observable<Holiday> {
  //   return this.http.post<Holiday>(this.api.holidaysApi, holiday)
  // }

  // update(id: string, holiday: Holiday): Observable<Holiday> {
  //   return this.http.put<Holiday>(`${this.api.holidaysApi}/${id}`, { ...holiday })
  // }

  create(data: Partial<Holiday>) {
    return this.http.post<Holiday>(this.api.holidaysApi, data)
  }

  update(id: string, data: Partial<Holiday>) {
    return this.http.put<Holiday>(`${this.api.holidaysApi}/${id}`, data)
  }

  delete(id: string): Observable<Holiday> {
    return this.http.delete<Holiday>(`${this.api.holidaysApi}/${id}`)
  }
}
